const appConfig = {
  name: 'ISEHOME',
  version: '1.0',
  copyright: `&copy; ${new Date().getFullYear()} ISEHOME UNITEN GRID ESS All Rights Reserved`,
};

export default appConfig;
